var moment = require('moment');
var vsprintf = require('sprintf-js').vsprintf;

var React = require('react');
var cx = require('classnames');
var Link = require('react-router').Link;
var Table = require('react-bootstrap').Table;

var InvoiceActions = require('../../actions/InvoiceActions');
var Currency = require('../../util/Currency');
var Invocation = require('../../api/Invocation');
var ClientStore = require('../../stores/ClientStore');
var InvoiceStore = require('../../stores/Invoice/InvoiceStore');
var Loading = require('../Loading');

function getState() {
  const client = ClientStore.get()

    return {
      clientId: client ? client.id : null,
      invoices: InvoiceStore.get().invoices.slice(0, 4),
      loading: InvoiceStore.loading(),
      credits: InvoiceStore.get().credits
    };
}

var SummaryTable = React.createClass({
    statics: {
        handleInvoiceClick: function (e, invoice) {
            var link = $(e.target);
            if (!link.is('a')) {
                link = link.closest('a');
            }

            link.attr('href', Invocation.invoice.buildPdfUrl(invoice));
        }
    },
    componentDidMount: function() {
        InvoiceStore.addChangeListener(this.update);
        ClientStore.addChangeListener(this.update);
    },
    componentWillMount: function () {
        InvoiceActions.getInvoices(1);
    },
    componentWillUnmount: function () {
        InvoiceStore.removeChangeListener(this.update);
        ClientStore.removeChangeListener(this.update);
    },
    getInitialState: function () {
        return getState();
    },

    render: function () {
      return <div>
        {this.state.credits && this.renderCredits()}
        <Table className="table-striped table-hover">
          <thead>
          <tr>
            <th>Invoice Number</th>
            <th>Date Due</th>
            <th>Total</th>
          </tr>
          </thead>
          <tbody>
          {this.state.loading && (
            <tr>
              <td colSpan={4}><Loading /></td>
            </tr>
          )}
          {this.state.invoices.map(this.renderInvoiceRow)}
          </tbody>
        </Table>
      </div>;
    },
    renderCredits: function () {
      let creditTotal = 0;
      for (let i = 0; i < this.state.credits.length; i++) {
        creditTotal += parseFloat(this.state.credits[i].credits);
      }

      if (creditTotal) {
        return <div className="alert alert-info">Your account has {Currency.format(creditTotal)} of credit.</div>;
      }
    },
    renderInvoiceRow: function (invoice) {
        const unpaid = invoice.outstanding > 0;
        const rowClasses = {
            danger: unpaid && moment(invoice.due_date).isBefore(),
            outstanding: unpaid && !moment(invoice.due_date).isBefore()
        };

        let number = <span>{invoice.number}</span>;
        if (invoice.pdfAvailable) {
            const click = e => SummaryTable.handleInvoiceClick.call(this, e, invoice);

            number = <a href="#" target="_new" onClick={click} onContextMenu={click}><i className="fa fa-file-pdf-o"></i> {invoice.number}</a>
        }

        return <tr key={invoice.id} className={cx(rowClasses)}>
            <td>{number}</td>
            <td>{moment(invoice.due_date).format('YYYY-MM-DD')}</td>
            <td>{Currency.format(invoice.total)}</td>
        </tr>
    },

    update: function () {
      const newState = getState()
      if (newState.clientId !== this.state.clientId) {
        InvoiceActions.getInvoices(1)
      }

      this.setState(newState);
    }
});
module.exports = SummaryTable;



// WEBPACK FOOTER //
// ./app/components/Invoice/SummaryTable.js